<template>
  <div id="page-not-found">
    <h1>{{ $t('message__page-not-found-1') }}</h1>
    <h3>{{ $t('message__page-not-found-2') }}</h3>
    <ButtonUpdate
      class="back-button"
      :title="$t('general__text__platform-back-to')"
      @clicked="backToPlatform"
    />
  </div>
</template>

<script>
import { getRealmId } from '@/utils/realmId'
import ButtonUpdate from '../components/general/buttons/ButtonUpdate/ButtonUpdate.vue'

export default {
  name: 'PageNotFound',
  components: {
    ButtonUpdate
  },
  data() {
    return {}
  },
  created() {
    const realmId = getRealmId()
    if (realmId === 'lc-and-partners' || realmId === 'mng' || realmId === 'geoimageservices') {
      this.$i18n.locale = 'en'
    }
  },
  methods: {
    backToPlatform() {
      // Using push instead of replace to make sure that the home component is reloaded (for example, the user could otherwise end up in the mapviev but with indoorviewer buttons and without buildings)
      this.$router.push('/home')
    }
  }
}
</script>

<style lang="scss" scoped>
@use '@/styles/variables.scss';
#page-not-found {
  padding: 30px;
}
.back-button {
  display: inline-flex;
  justify-content: center;
  margin-top: 10px;
  width: 200px;
}
</style>
